import { Box, Typography } from '@mui/material'
import { fontSizes, fontWeights } from '../../Components/Common/Typography/TypographyStyles'

const ComingSoonPage = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        textAlign: 'center',
      }}
    >
      <Typography
        variant='h3'
        color='primary'
        sx={{ fontWeight: fontWeights[700], fontSize: fontSizes.size64 }}
      >
        Coming Soon
      </Typography>
      <Typography variant='h6' sx={{ marginY: 2, fontSize: fontSizes.size16 }}>
        We&apos;re working hard to get this ready for you.
      </Typography>
    </Box>
  )
}

export default ComingSoonPage
